import "./styles.less";

import { Popover } from "antd";
import React from "react";

export const CustomCell = ({ date, month, occupancies }) => {
	const marked = occupancies.some(elem => elem == date.format("YYYY-MM-DD"));
	if (month.month() != date.month()) return null;

	return (
		<Popover content={marked ? "No disponible" : "Disponible"}>
			<div className={"calendar-cell" + (marked ? " calendar-cell-marked" : "")}>
				{date.format("DD")}
			</div>
		</Popover>
	);
};
